/* eslint-disable */
import $ from 'jquery';
import _ from 'underscore';
import ko from 'knockout';
import Base from '@bingads-webui-static-legacy/bulk-edit/viewmodel/bulkEditJob';
import actions from '@bingads-webui-static-legacy/schema/bulkEdit/changeBidActions';
import * as POUtils from '@bingads-webui-campaign/target-bid-adjustment';
import numericActionType from '@bingads-webui-static-legacy/schema/bulkEdit/numericActionType';
import decimalNumber from '@bingads-webui-component-legacy/humanize/decimal';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var i18nAudience = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/audience-campaign');
var validateNumber = function (value) {
  return POUtils.isCashbackPercentValid(value, decimalNumber);
};
var ViewModel = function (options) {
  Base.call(this);
  var actionOptions = _.compact([{
    Value: 'SetAmount',
    Text: i18n.getString('BulkEdit_AdGroup_SetBidOption_CashbackPercent')
  }, !options.isCampaignBulkEdit && ({
    Value: 'Remove',
    Text: i18n.getString('BulkEdit_CashbackPercent_SetToInherit')
  }), {
    Value: 'NoCashback',
    Text: i18n.getString('BulkEdit_CashbackPercent_SetToNoCashback')
  }]);
  this.actions = actionOptions;
  this.selectedAction = ko.observable(actions.Set);
  this.selectedAction.subscribe(function () {
    this.errorMessage('');
  }, this);
  this.showSetPanel = ko.computed(function () {
    var result = this.selectedAction() === actions.SetAmount;
    return result;
  }, this);
  this.selectedUnit = ko.observable('%');
  this.cashbackPercent = ko.observable();
  this.cashbackPercentValue = ko.computed({
    read: function () {
      return this.cashbackPercent();
    },
    write: function (value) {
      this.errorMessage('');
      this.cashbackPercent(value);
    },
    owner: this
  });
  this.titleText = ko.computed(function () {
    return i18n.getString('BulkEdit_CashbackPercent_HeaderText');
  }, this);
  this.doesIncludeExcludeItems = ko.observable(false);
  this.doesIncludeExcludeItemsText = ko.observable(i18n.getString('BulkEdit_ProductGroup_IncludeExcludedItems'));
  this.getCashbackPercentValueByAction = function () {
    var selectedAction = this.selectedAction();
    var cashbackPercentValue;
    switch (selectedAction) {
      case numericActionType.remove:
        cashbackPercentValue = -1;
        break;
      case numericActionType.noCashback:
        cashbackPercentValue = 0;
        break;
      default:
        if (cashbackPercentValue === '') {
          cashbackPercentValue = -1;
        } else {
          cashbackPercentValue = decimalNumber.fromLocalToFloat(this.cashbackPercentValue());
        }
        break;
    }
    return cashbackPercentValue;
  };
  this.cashbackPercentDescription = ko.observable(options.cashbackPercentDescription);
  this.validate = function () {
    this.errorMessage('');
    var selectedAction = this.selectedAction();
    var cashbackPercentValue = this.cashbackPercentValue();
    if (!cashbackPercentValue && selectedAction !== 'Remove' && selectedAction !== 'NoCashback') {
      return true;
    }
    if (cashbackPercentValue && selectedAction !== 'Remove' && selectedAction !== 'NoCashback') {
      var result = validateNumber(cashbackPercentValue);
      if (!result) {
        this.errorMessage(POUtils.getCashbackPercentValidationError(cashbackPercentValue, i18nAudience, decimalNumber));
        return false;
      }
    }
    return true;
  };
};
export default ViewModel;

